const RFC2047_WORD = /=\?([^?]+)\?([BbQq])\?([^?]*)\?=/g;

function decodeRfc2047Payload(charset: string, encoding: string, payload: string): string {
  let bytes: Uint8Array;
  if (encoding.toUpperCase() === "Q") {
    const expanded = payload.replace(/_/g, " ");
    const parts: number[] = [];
    for (let i = 0; i < expanded.length; i++) {
      if (expanded[i] === "=" && i + 2 < expanded.length) {
        const hex = expanded.slice(i + 1, i + 3);
        if (/^[0-9A-Fa-f]{2}$/.test(hex)) {
          parts.push(parseInt(hex, 16));
          i += 2;
          continue;
        }
      }
      parts.push(expanded.charCodeAt(i) & 0xff);
    }
    bytes = new Uint8Array(parts);
  } else {
    try {
      const binary = atob(payload.replace(/\s+/g, ""));
      bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    } catch {
      return payload;
    }
  }

  const upper = charset.toUpperCase();
  if (upper === "UTF-8" || upper === "US-ASCII" || upper === "DEFAULT" || upper === "") {
    return new TextDecoder("utf-8").decode(bytes);
  }
  try {
    return new TextDecoder(upper).decode(bytes);
  } catch {
    return new TextDecoder("utf-8").decode(bytes);
  }
}

const RFC2047_DETECT = /=\?[^?]+\?[BbQq]\?/;

type DecodeMimeWordsOptions = {
  /** Pour sujet/expéditeur : aplatit les espaces. Corps : laisser false. */
  collapseSpaces?: boolean;
};

function replaceRfc2047Words(text: string): string {
  return text.replace(RFC2047_WORD, (_match, charset, enc, payload) =>
    decodeRfc2047Payload(String(charset), String(enc), String(payload))
  );
}

function decodeMimeWordsCore(text: string): string {
  if (!text || !text.includes("=?")) return text;

  let decoded = replaceRfc2047Words(text);

  let guard = 0;
  while (decoded.includes("=?") && guard < 8) {
    const next = replaceRfc2047Words(decoded);
    if (next === decoded) break;
    decoded = next;
    guard += 1;
  }

  return decoded;
}

/** Décode les mots RFC 2047 (=?UTF-8?Q?...?=) côté client (cache local ancien). */
export function decodeMimeWords(text: string, options: DecodeMimeWordsOptions = {}): string {
  const decoded = decodeMimeWordsCore(text);
  if (options.collapseSpaces) {
    return decoded.replace(/\s+/g, " ").trim() || decoded;
  }
  return decoded;
}

export function sanitizeMailDisplayText(text: string | undefined): string {
  if (!text) return "";
  return decodeMimeWords(text, { collapseSpaces: true });
}

export function stillHasRfc2047Encoding(text: string | undefined): boolean {
  if (!text?.trim()) return false;
  return RFC2047_DETECT.test(text);
}